export default "__VITE_ASSET__CGgbIMOh__"